import React from 'react';
import { FinancialValue } from './shared/FinancialValue';

interface ClaimBreakdownProps {
  step1_variable_profit_loss: number;
  step2_incremental_revenue_loss: number;
  final_claim_amount: number;
  notes?: string[];
}

export default function ClaimBreakdown({ step1_variable_profit_loss, step2_incremental_revenue_loss, final_claim_amount, notes }: ClaimBreakdownProps) {

  return (
    <div className="rounded-lg border-2 p-6" style={{ backgroundColor: 'var(--color-needs-human-tint)', borderColor: 'var(--color-needs-human-tint-bd)' }}>
      <h3 className="text-xl font-bold mb-4" style={{ color: 'var(--color-text-primary)' }}>BI Claim Calculation</h3>

      <div className="space-y-4">
        {/* Step 1 */}
        <div className="rounded-lg p-4 border" style={{ backgroundColor: 'var(--color-bg-surface)', borderColor: 'var(--color-border)' }}>
          <div className="flex items-start justify-between mb-2">
            <div>
              <div className="flex items-center gap-2">
                <span className="text-xs font-bold px-2 py-1 rounded" style={{ backgroundColor: 'var(--color-brand)', color: 'var(--color-on-brand)' }}>STEP 1</span>
                <h4 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>Variable Profit Loss</h4>
              </div>
              <p className="text-sm mt-1" style={{ color: 'var(--color-text-secondary)' }}>Decline in gross receipts during covered period</p>
            </div>
            <div className="text-right">
              <p className="text-2xl font-bold" style={{ color: 'var(--color-needs-human-text)' }}><FinancialValue value={step1_variable_profit_loss} /></p>
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div className="rounded-lg p-4 border" style={{ backgroundColor: 'var(--color-bg-surface)', borderColor: 'var(--color-border)' }}>
          <div className="flex items-start justify-between mb-2">
            <div>
              <div className="flex items-center gap-2">
                <span className="text-xs font-bold px-2 py-1 rounded" style={{ backgroundColor: 'var(--color-brand)', color: 'var(--color-on-brand)' }}>STEP 2</span>
                <h4 className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>Incremental Revenue Loss</h4>
              </div>
              <p className="text-sm mt-1" style={{ color: 'var(--color-text-secondary)' }}>Additional loss beyond benchmark period</p>
            </div>
            <div className="text-right">
              <p className="text-2xl font-bold" style={{ color: 'var(--color-needs-human-text)' }}><FinancialValue value={step2_incremental_revenue_loss} /></p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t-2 border-dashed my-4" style={{ borderColor: 'var(--color-border)' }}></div>

        {/* Final Amount */}
        <div className="rounded-lg p-5" style={{ backgroundColor: 'var(--color-brand)', color: 'var(--color-on-brand)' }}>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm opacity-90 mb-1">FINAL CLAIM AMOUNT</p>
              <h3 className="text-4xl font-bold"><FinancialValue value={final_claim_amount} /></h3>
            </div>
            <div className="text-6xl opacity-50">✓</div>
          </div>
        </div>
      </div>

      {/* Notes */}
      {notes && notes.length > 0 && (
        <div className="mt-4 p-3 border rounded" style={{ backgroundColor: 'var(--color-needs-human-tint)', borderColor: 'var(--color-needs-human-tint-bd)' }}>
          <p className="text-xs font-semibold mb-1" style={{ color: 'var(--color-needs-human-text)' }}>Calculation Notes:</p>
          <ul className="text-xs space-y-1" style={{ color: 'var(--color-text-secondary)' }}>
            {notes.map((note, idx) => (
              <li key={idx}>• {note}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="mt-4 text-xs text-center" style={{ color: 'var(--color-text-muted)' }}>
        Calculation based on BI methodology using 48 expense categories and benchmark analysis
      </div>
    </div>
  );
}
